export default function dateToISOString (date, endOfDay = false) {
    const isoDate = new Date(date);

    // Get offset date
    let offset = isoDate.getTimezoneOffset()
    // Add hours with offset to the date
    isoDate.setUTCMinutes(offset)

    // Get hours from date
    let hoursTimeDate = String(isoDate.getHours())

    const isoYear = isoDate.getFullYear();
    const isoMonth = String(isoDate.getMonth() + 1).padStart(2, '0');
    const isoDay = String(isoDate.getDate()).padStart(2, '0');

    // Add the hours from date to the isoTime
    let isoTime = '';
    if (hoursTimeDate.length < 2)
      isoTime = endOfDay ? `T0${hoursTimeDate}:59:59.999Z` : `T0${hoursTimeDate}:00:00.000Z`;
    else
      isoTime = endOfDay ? `T${hoursTimeDate}:59:59.999Z` : `T${hoursTimeDate}:00:00.000Z`;

    return `${isoYear}-${isoMonth}-${isoDay}${isoTime}`;
  };